export default {"src":"/_next/static/media/Emc2.b636e2a0.svg","height":10,"width":46,"blurWidth":0,"blurHeight":0};